<script setup lang="ts">
import ModalSplash from '@ui/base-components/modal/Splash'
import {
  useDataHome,
} from '@/composables/useDataHome'

// ** props
defineProps({
  id: {
    type: Number,
    default: 1,
  },
})

const {
  labels,
  attractions,
  facilities,
  aboutImages,
  profile,
  meetings,
  events,
  press,
  offers,
  rooms,
  galleries,
  splashOffers,
  isModalSplash,
  dialogSplash,
  disableSplashScreen,
  loadingOffers,
} = useDataHome()

const scrollTop = ref(0)
function animateBookingNowMenuBtn() {
  if (document && window) {
    window.addEventListener('scroll', () => {
      scrollTop.value = window.pageYOffset || window.scrollY
      const bookingBtn = document.querySelectorAll('.booking-btn')
      if (scrollTop.value >= 800) {
        bookingBtn.forEach((el: Element) => el.classList.add('show'))
        if (document.querySelector('.booking-btn')) {
          bookingBtn.forEach((el: Element) => {
            if (el.parentElement)
              el.parentElement.classList.add('show')
          })
        }
      }
      else {
        bookingBtn.forEach((el: Element) => el.classList.remove('show'))
        if (document.querySelector('.booking-btn')) {
          bookingBtn.forEach((el: Element) => {
            if (el.parentElement)
              el.parentElement.classList.remove('show')
          })
        }
      }
    })
  }
}

// ** onMounted
onMounted(async () => {
  await nextTick(() => {
    animateBookingNowMenuBtn()
  })
})
</script>

<template>
  <div id="section-home" class="m-0 p-0">
    <LazyComponentsHomeHero
      id="section-home"
      :labels="labels"
      :profile="profile"
      :disabled="false"
    />
    <LazyComponentsHomeAboutUs
      v-if="Array.isArray(aboutImages) && aboutImages.length && labels?.HOME_ABOUT_TITLE"
      id="section-about-us"
      :profile="profile"
      :labels="labels"
      :images="aboutImages"
    />
    <LazyComponentsHomeRooms
      v-if="Array.isArray(rooms) && rooms.length"
      id="section-rooms"
      :labels="labels"
      :profile="profile"
      :rooms="rooms"
    />
    <LazyComponentsHomeDevider
      v-if="labels?.HOME_DEVIDER_IMAGE"
      :labels="labels"
      :profile="profile"
    />
    <LazyComponentsHomeFacilities
      v-if="Array.isArray(facilities) && facilities.length"
      :labels="labels"
      :profile="profile"
    />
    <LazyComponentsHomeOffers
      v-if="Array.isArray(offers) && offers.length"
      id="section-offers"
      :labels="labels"
      :profile="profile"
      :offers="offers"
    />
    <LazyComponentsHomeWhatsNew
      v-if="Array.isArray(press) && press.length"
      id="section-whats-new"
      :labels="labels"
      :press="press"
    />
    <LazyComponentsHomeGallery
      v-if="Array.isArray(galleries) && galleries.length"
      id="section-photos"
      :labels="labels"
      :profile="profile"
    />
  </div>
  <ModalSplash
    id="modal-offers-splash"
    v-model:show="isModalSplash"
    v-model="splashOffers"
    dimension=""
    :loading="loadingOffers"
    :profile="profile"
    :labels="labels"
  />
</template>
